import React from "react";
import styled from "styled-components/macro";
import {
  TableCell as MuiTableCell,
  TableRow as MuiTableRow,
  Typography as MuiTypography,
  Button as MuiButton,
  Box as MuiBox
} from "@mui/material";
import { spacing, SpacingProps } from "@mui/system";
import "react-dragula/dist/dragula.css";
export const Box = styled(MuiBox)``;
interface ButtonProps extends SpacingProps {
  component?: React.ElementType;
  to?: string;
  target?: string;
}
export const Button = styled(MuiButton)<ButtonProps>(spacing);

export const CustomButton: any = styled(MuiButton)`
  color: #223354;
  &.blue_button {
    background-color: blue;
  }

  &.custom_disabled {
    background-color: grey !important;
  }
`;
interface TypographyProps extends SpacingProps {
  component?: string;
}
export const Typography = styled(MuiTypography)<TypographyProps>(spacing);

export const TableCellHeading = styled(MuiTableCell)`
  color: var(--light-text-primary, #192f67);
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.17px;
  padding-right: 5px;
`;

export const TableCellColumn = styled(MuiTableCell)`
color: var(--light-text-secondary, rgba(0, 0, 0, 0.60));
font-family: Montserrat,sans-serif;
font-size: 14px;
font-style: normal;
font-weight: 400;
line - height: normal;
`;

export const TableRow = styled(MuiTableRow)``;

export const CustomTableRow: any = styled(MuiTableRow)`
  &:hover {
    background-color: #f2f5f9;
    cursor: pointer;
  }
`;
